import Slider from 'antd/lib/slider'
import './index.less'

export default Slider



// WEBPACK FOOTER //
// ./src/elements/slider/index.js